/* @flow */
export const REPORTS_ENDPOINT = '/services/incident-reports';
export const PAGE_SIZE = 25; // Number of reports to fetch per page
export const CORRELATION_COUNT_LOADING = '-';
export const MAX_TAG_LENGTH = 90;

export const MAX_RETRY_NEW_REPORT_POLLING = 15;


// WEBPACK FOOTER //
// ./src/app/modules/reports/constants.js